// /src/components/GlobalMessage.js
import React from "react";
import { Snackbar, Alert } from "@mui/material";

const GlobalMessage = ({
  open,
  onClose,
  message,
  severity = "info", // 'success', 'warning', 'error', 'info'
  autoHideDuration = 6000,
}) => {
  return (
    <Snackbar
      open={open}
      autoHideDuration={autoHideDuration}
      onClose={onClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
    >
      <Alert onClose={onClose} severity={severity} sx={{ width: "100%" }}>
        {message}
      </Alert>
    </Snackbar>
  );
};

export default GlobalMessage;
